/*
* @Author: Jens K
* @Date:   2017-12-19 10:29:49
* @Last Modified by:   Jens K
* @Last Modified time: 2018-01-29 09:54:10
*/
require('./bootstrap');
require('jquery-match-height');
require('parsleyjs');
require('./main/locale');
require('bootstrap-datepicker');
require('select2');

require('./main/filter');
require('./main/carousel');
require('./main/imageGallery');
require('./main/form-slider');
require("flatpickr");
require("flatpickr/dist/l10n/nl.js").default.nl;

function navigation(){

    var nav = $('.nav'),
        checkNav = false,
        mobileTrigger = $('.nav--main--trigger');

    if (nav.hasClass('nav--transparent')) {
        checkNav = true;
    }

    function checkScrollPos(){

        var scroll = $(window).scrollTop();

        if (scroll >= 80) {

            nav.removeClass('nav--transparent').addClass('nav--blue');

        } else {

            nav.removeClass('nav--blue').addClass('nav--transparent');

        }

    }

    mobileTrigger.on('click', function(e){

        e.preventDefault();

        mobileTrigger.toggleClass('is-open');
        $('.nav--main--wrap').toggleClass('is-open');
        $('.nav--logo').toggleClass('is-open');
        $('.nav--login').toggleClass('is-open');

    });

    $(window).scroll(function() {

        if (checkNav) {

            checkScrollPos();

        }

    });

    if (checkNav) {

        checkScrollPos();

    }

    function subNav() {

        var triggerSubnav = $('.trigger--subnav'),
            subNav = $('.nav--main__subnav'),
            subNavId, leftPos, topPos;

        triggerSubnav.hover(function() {

            subNavId = $(this).data('subnav');

            leftPos = $(this).offset().left;
            topPos = $(this).outerHeight();

            $('#' + subNavId).addClass('is-active').fadeIn(150).css({
                top: topPos,
                left: leftPos
            });

        }, function() {

            setTimeout(function(){

                if (!$('#' + subNavId).hasClass('is-hovering')){

                    $('#' + subNavId).removeClass('is-active').fadeOut(150);

                }

            }, 500);

        });

        subNav.hover(function(){

            $(this).addClass('is-hovering');

        }, function(){

            $(this).removeClass('is-hovering is-active').fadeOut(150);

        });

    }

    function navSearch(){

        var searchTrigger = $('.nav--search--form button'),
            searchField = $('.nav--search--field'),
            searchWrap = $('.nav--login'),
            searchClose = $('.close--form'),
            submitForm = false;

        searchTrigger.on('click', function(e){

            e.preventDefault();

            if (!searchWrap.hasClass('search--form--open')) {

                searchWrap.addClass('search--form--opening');

                setTimeout(function(){

                    searchWrap.addClass('search--form--open').removeClass('search--form--opening');
                    searchField.animate({opacity: 1}, 300);
                    searchClose.animate({opacity: 1}, 300);

                }, 350);

            } else {

                $('.nav--search--form').submit();

            }

        });

        searchClose.on('click', function(e){

            e.preventDefault();

            searchWrap.removeClass('search--form--open').addClass('search--form--closing');
            searchField.animate({opacity: 0}, 300);
            searchClose.animate({opacity: 0}, 300);

            setTimeout(function(){

                searchWrap.removeClass('search--form--closing');

            }, 300);

        });

    }

    if ($(window).width() > 1023) {

        subNav();

    }

    navSearch();

}

function footer() {

    var footerItem = $('.footer--item'),
        footerTrigger = $('.footer--item--title'),
        footerContent = $('.footer--item--list'),
        allowOpen = true;

    function footerOps(){

        footerTrigger.on('click', function(e){

            if (allowOpen) {

                e.preventDefault();

                if ($(this).hasClass('active')) {

                    $(this).removeClass('active');
                    $(this).parent().find(footerContent).slideUp();

                } else {

                    footerTrigger.removeClass('active');
                    footerContent.slideUp();

                    $(this).addClass('active');
                    $(this).parent().find(footerContent).slideDown();

                }

            }

        });

    }

    if ($(window).width() < 640) {

        footerOps();

    }

}

function homeVideoPlayer(){

    var videoPlayer = $('.video--player');

    if (videoPlayer.length) {

        // init api
        var tag = document.createElement('script');
        tag.src = "https://www.youtube-nocookie.com/iframe_api";

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var player;

        window.onYouTubeIframeAPIReady = function() {

            player = new YT.Player('video-player', {
                height: '390',
                width: '640',
                videoId: videoPlayer.data('ytid'),
                color: 'white'
            });

        }

    }

}

function mobileFilter(){

    var mobileFilterTrigger = $('.filter--closed button'),
        mobileFilterCloser = $('.filter--open button'),
        filterContent = $('.filter--content');

    mobileFilterTrigger.on('click', function(e){

        e.preventDefault();
        $('.filter--closed').hide();
        $('.filter--open').show();
        filterContent.show();

    });

    mobileFilterCloser.on('click', function(e){

        e.preventDefault();
        $('.filter--open').hide();
        $('.filter--closed').show();

        //trigger enter keypress on search input to trigger search
        var e = jQuery.Event("keydown");
        e.which = 13; // # Some key code value
        $('#filter-search-input').trigger(e);

        filterContent.hide();

    });

}

function checkoutStep4(){
    $(document).ready(function () {
        $('#checkoutForm').submit(function () {
            $('#submitButton').prop('disabled', true);
        });
    });
}

function checkout(){

    var checkoutFlow = $('.checkout--flow');

    function step1() {

        var userCheckBox = $('.user--selection'),
            userList = $('.selected_persons--list'),
            checkedBox = $('.user--selection:checked'),
            userId, userName, userListItem;

        userCheckBox.on('change', function(){

            userId = $(this).attr('id');
            userName = $(this).parent().find('.user--name p').html();
            userListItem = '<li class="' + userId + '"><h5 class="user-name">' + userName + '</h5> <label for="' + userId + '" class="delete">verwijderen uit selectie</label></li>';

            if (userList.has('li') && userList.find('li').hasClass(userId)) {

                $('.' + userId).remove();

            } else {

                userList.append(userListItem);

            }

        });

        checkedBox.each(function(){

            userId = $(this).attr('id');
            userName = $(this).parent().find('.user--name p').html();
            userListItem = '<li class="' + userId + '"><h5 class="user-name">' + userName + '</h5> <label for="' + userId + '" class="delete">verwijderen uit selectie</label></li>';

            userList.append(userListItem);

        });

    }

    step1();

}

function filterOverview() {

    var filter = $('.aanbod--overview');
    var related = $('.related--items');

    if (filter.length) {

        $('.filter--result--content .list--logo_icon').matchHeight();
        $('.filter--result--content .filter--result--name').matchHeight();

    }

    if (related.length) {

        $('.related--items .list--logo_icon').matchHeight();
        $('.related--items .filter--result--name').matchHeight();

    }

}

function events(){

    var eventTrigger = $('.trigger--event--info'),
        closeEvent = $('.close--event'),
        eventItem;

    eventTrigger.on('click', function(e){

        $('.events--item').removeClass('event--open large-6 medium-8').addClass('large-3 medium-4');

        e.preventDefault();
        eventItem = $(this).parents('.events--item');

        eventItem.addClass('event--open large-6 medium-8').removeClass('large-3 medium-4');

    });

    closeEvent.on('click', function(){

        $('.events--item').removeClass('event--open large-6 medium-8').addClass('large-3 medium-4');

    });

}

function monitorForm() {

    var form = $('.become--monitor--form');

    if (!form) { return; }

    var statuutSelect = form.find('#statuut');

    if (statuutSelect.val() == 'zelfstandige') {

        $('.consultant__fields').removeClass('hide');
        $('.consultant__fields').find('input').attr('data-parsley-required', 'true');

    }

    statuutSelect.on('change', function (slct) {

        var slctValue = statuutSelect.val();

        if (slctValue == 'zelfstandige') {

            $('.consultant__fields').removeClass('hide');
            $('.consultant__fields').find('input').attr('data-parsley-required', 'true');

        } else {

            $('.consultant__fields').addClass('hide');
            $('.consultant__fields').find('input').attr('data-parsley-required', 'false');

        }

    });

}

function userProfile(){
    let fiscalCertificateUseDifferentProfile = $('input[name="user[fiscal_certificate_use_different_profile]"]');
    let fiscalCertificateUseDifferentProfileDiv = $('#fiscal_certificate_use_different_profile');

    fiscalCertificateUseDifferentProfile.on('change', function () {
        // Find the checked radio button within the group
        let selectedRadioButton = $('input[name="user[fiscal_certificate_use_different_profile]"]:checked');

        if (selectedRadioButton.length > 0 && selectedRadioButton.val() === '1') {
            fiscalCertificateUseDifferentProfileDiv.show();
        } else {
            fiscalCertificateUseDifferentProfileDiv.hide();
        }
    });
}

function validateForms(){

    // add rijksregister validation
    window.Parsley.addValidator('rijksregister', {
        validateString: function(value) {
            var rr = value.split('-').join('');
            var n = rr.split('.').join('');

            if (n.length != 11)
                return false;

            var checkDigit = n.substr(n.length - 2, 2);
            var modFunction = function(nr) { return 97 - (nr % 97); };
            var nrToCheck = parseInt(n.substr(0, 9));

            // first check without 2
            if (modFunction(nrToCheck) == checkDigit)
                return true;

            // then check with 2 appended for y2k+ births
            nrToCheck = parseInt('2' + n.substr(0, 9));

            return (modFunction(nrToCheck) == checkDigit);
        },
        messages: {
            nl: 'Gelieve een correct rijksregisternummer in te geven.'
        }
    });

    if ($('.validate--form').length){

        $('.validate--form').parsley({
            errorClass: "error",
            errorsWrapper: '<div></div>',
            errorTemplate: '<span class="error"></span>'
        });

    }

}

function accordion(){

    var accordion = $('.accordion'),
        accordionItem = accordion.find('li'),
        accordionTitle = $('.acc-title'),
        accordionContent = $('.acc-content'),
        accordionTarget;

    if (accordion.length) {

        accordionTitle.on('click', function(e){

            e.preventDefault();

            accordionTarget = $(this).parent();

            if (!accordionTarget.hasClass('is--open')) {

                accordionItem.removeClass('is--open');
                accordionItem.find(accordionContent).slideUp(300);

                accordionTarget.addClass('is--open');
                accordionTarget.find(accordionContent).slideDown(300);

            } else {

                accordionTarget.removeClass('is--open');
                accordionTarget.find(accordionContent).slideUp(300);

            }

        });

    }

}

function datePicker(){

    flatpickr.localize(flatpickr.l10ns.nl);
    $('input[type=date]').flatpickr({
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Y-m-d",
    });

}

function eventOverlay(){

    var eventOverlay = $('.event--overlay'),
        eventSeen = false,// Cookies.get('event__seen'),
        eventClose = $('.event--overlay--close'),
        eventBack = $('.event--overlay--back');

    if (eventOverlay.length && eventSeen != 'true') {

        eventOverlay.addClass('is--open').show();

    } else {

        eventOverlay.remove();
        eventBack.remove();

    }

    function closeOverlay(){

        eventOverlay.fadeOut(300);
        eventBack.fadeOut(300);

        setTimeout(function(){

            eventOverlay.remove();
            eventBack.remove();

        }, 500);

        Cookies.set('event__seen', 'true', { expires: 7 });

    }

    eventClose.on('click', function(e){

        e.preventDefault();
        closeOverlay();

    });

    eventBack.on('click', function(e){

        e.preventDefault();
        closeOverlay();

    });

}

function numberedField(){

    // Disable scroll when focused on a number input.
    $('form').on('focus', 'input[type=number]', function(e) {
        $(this).on('wheel', function(e) {
            e.preventDefault();
        });
    });

    // Restore scroll on number inputs.
    $('form').on('blur', 'input[type=number]', function(e) {
        $(this).off('wheel');
    });

    // Disable up and down keys.
    $('form').on('keydown', 'input[type=number]', function(e) {
        if ( e.which == 38 || e.which == 40 ) {
            e.preventDefault();
        }
    });

}

function animateBrochure() {
    setTimeout(function () {
        $('.hero__content__brochure').animate({
            'right': '0px'
        }, 4000);
    }, 2000);
}

function notificationBar() {
    function getCookieName() {
        return 'notification_closed_' + notification.id;
    }

    function setClosedNotificationCookie() {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);

        document.cookie = getCookieName() + '=true; expires=' + expirationDate.toUTCString() + '; path=/';
    }

    function hasClosedNotification() {
        return document.cookie.indexOf(getCookieName() + '=true') !== -1;
    }

    if (typeof notification !== 'undefined' && notification && !hasClosedNotification()) {
        var topBar = $('<div id="notification-bar">'+ notification.text+'<div class="notification-bar-close">×</div></div>');

        $('nav').prepend(topBar).addClass('nav--notification-bar');

        $('.notification-bar-close').click(function () {
            setClosedNotificationCookie();

            topBar.slideUp();

            $('nav').removeClass('nav--notification-bar');
        });
    }
}

function animateReviews() {
    setInterval(function () {
        $('.review--content:first').addClass('fade-out');

        setTimeout(function () {
            $('.review--content:first').appendTo('.review--content--wrapper').removeClass('fade-out');
        }, 2000);

    }, 8000);
}

$(document).ready(function() {

    navigation();
    footer();
    homeVideoPlayer();
    mobileFilter();
    checkout();
    checkoutStep4();
    filterOverview();
    events();
    validateForms();
    accordion();
    datePicker();
    eventOverlay();
    numberedField();
    monitorForm();
    userProfile();
    animateBrochure();
    notificationBar();
    animateReviews();

});

